"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringContainsMarkdown = exports.findValuesByKey = exports.contentKeyValuePair = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
var _handlebars = _interopRequireDefault(require("handlebars"));
var _snarkdown = _interopRequireDefault(require("./snarkdown"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var brands = ['shared', 'very', 'littlewoods', 'veryireland'];

/**
 * Helper to search API response for a given key.
 * @param {Object} data - The data object (API response) of hierarchy KVP
 * @param {string} key - The key for the value to return
 * @param {string} brand - The brand used for value localisation, this is either shared, very, littlewoods or veryireland.
 * @returns {string[]} - The values string array for given key
 */
var findValuesByKey = exports.findValuesByKey = function findValuesByKey(data, key, brand) {
  var _targetResponse$conte;
  if (!brands.indexOf(brand > -1) || !key || !data || !Array.isArray(data.responses)) return null;
  var responses = data.responses;
  var targetResponse = responses.find(function (response) {
    var _response$content;
    var pairs = response === null || response === void 0 || (_response$content = response.content) === null || _response$content === void 0 ? void 0 : _response$content.pairs;
    return Array.isArray(pairs) && pairs.some(function (pair) {
      var _pair$values;
      return pair.key === key && Array.isArray((_pair$values = pair.values) === null || _pair$values === void 0 ? void 0 : _pair$values[brand]);
    });
  });
  var targetValues = (targetResponse === null || targetResponse === void 0 || (_targetResponse$conte = targetResponse.content) === null || _targetResponse$conte === void 0 || (_targetResponse$conte = _targetResponse$conte.pairs.find(function (pair) {
    return pair.key === key;
  })) === null || _targetResponse$conte === void 0 || (_targetResponse$conte = _targetResponse$conte.values) === null || _targetResponse$conte === void 0 ? void 0 : _targetResponse$conte[brand]) || null;
  return targetValues;
};

/**
 * Helper to determine if a string *could* contain markdown syntax.
 * @param {String} text - The text which may contain markdown
 * @returns {boolean} - If text could contain markdown
 */
var stringContainsMarkdown = exports.stringContainsMarkdown = function stringContainsMarkdown(text) {
  if (typeof text !== 'string') {
    return false;
  }
  return /[#_*[\]`!-+]/.test(text);
};

/**
 * Helper to process markdown with Handlebars templating and sanitize the output.
 * @param {Object} data - The hierarchy data from amplience.
 * @param {string} key - The key of Key Value Pairs.
 * @param {string} brand - The brand used for value localisation, this is either shared, very, littlewoods or veryireland.
 * @param {object} tokens - The data object with for handling dynamic values using Handlebars i.e. {{fs.bnpl.terms}}.
 * @returns {string} - The sanitized HTML string ready for React rendering.
 */
var contentKeyValuePair = exports.contentKeyValuePair = function contentKeyValuePair(data, key, brand, tokens) {
  if (!brands.indexOf(brand > -1) || !data || !key || !Array.isArray(data.responses)) return null;
  var templates = findValuesByKey(data, key, brand);
  if (!templates) return null;

  /* Templates can be an array, in which case we want to operate on each */
  var values = templates.map(function (template) {
    var markdown = template;

    /* Only use Handlebars if there are tokens to replace */
    if (tokens && _typeof(tokens) === 'object') {
      var compiledTemplate = _handlebars["default"].compile(template);
      markdown = compiledTemplate(tokens);
    }
    var html = markdown;

    /* Only use Snarkdown if there could be markdown */
    if (stringContainsMarkdown(markdown)) {
      html = (0, _snarkdown["default"])(markdown);
    }
    var sanitisedHTML = _dompurify["default"].sanitize(html);

    // By default only markdown links open in new tab
    var returnedText = sanitisedHTML.replace("class=\"markdown__link\"", "class=\"markdown__link\" target=\"_blank\"");
    return returnedText;
  });
  if (values.length === 1) return values[0];
  return values;
};